import { render, staticRenderFns } from "./WarrantyDetail.vue?vue&type=template&id=02651b84&"
import script from "./WarrantyDetail.vue?vue&type=script&lang=js&"
export * from "./WarrantyDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports